// extracted by mini-css-extract-plugin
module.exports = {"host":"Hosts_host__ZjPE1","name":"Hosts_name__cFcCF"};